export const FOURSEAM = { name: '4Seamer',
    description: '85-105 mph | Fastest, straightest pitch. Little to no movement.',
    photo: '/pitches/4seamfastball.png',
}
export const TWOSEAM = { name: '2Seamer',
    description: '80-90 mph | Also known as a Sinker. Moves downward, and depending on the release, will sometimes run in on a RHH',
    photo: '/pitches/2seam.png',
}

export const CUTTER = { name: 'Cutter',
    description: '85-95 mph | Breaks away from a RHH as it reaches the plate. Mix of a slider and a fastball. Faster than a slider but with more movement than a fastball.',
    photo: '/pitches/cutter.png',
}

export const SPLITTER = { name: 'Splitter',
    description: '80-90 mph | Looks like a fastball but drops off the table as it reaches the plate.',
    photo: '/pitches/splitter.png',
}

export const FORK = { name: 'Forkball',
    description: '75-85 mph | Like a splitter, but with a less dramatic, more gradual downward movement.',
    photo: '/pitches/forkball.png',
}

export const CURVEBALL = { name: 'Curveball',
    description: '70-80 mph | Breaks down and away from a RHH. Slower than a slider with more movement. Commonly called a 12-6 curveball. The 12-6 refers to the top to bottom movement',
    photo: '/pitches/curve.png',
}

export const SLIDER = { name: 'Slider',
    description: '80-90 mph | Breaks down and away from a RHH. Between a fastball and a curve.',
    photo: '/pitches/slider.png',
}

export const SLURVE = { name: 'Slurve',
    description: '70-80 mph | 11-5 movement. Similar to a curve but with more lateral movement.',
    photo: '/pitches/slurve.png',
}

export const SCREWBALL = { name: 'Screwball',
    description: '70-80 mph | Breaks down and in on a RHH. 1-7 movement. Opposite of the slurve.',
    photo: '/pitches/screwball.png',
}

export const CHANGEUP = { name: 'Changeup',
    description: '70-85 mph | Looks like a fastball but is much slower. Slows down the batter’s timing.',
    photo: '/pitches/changeup.png',
}

export const PALMBALL = { name: 'Palmball',
    description: '65-75 mph | Ball is gripped tightly in palm. Just like a changeup, this pitch is slower than a fastball, but thrown with the same arm motion.',
    photo: '/pitches/palmball.png',
}



export const CIRCLECHANGE = { name: 'Circle Changeup',
    description: '70-80 mph | A changeup with 1-7 moment like the screwball.',
    photo: '/pitches/2seam.png',
}

